import { FolderOpen } from "lucide-react";
import React from "react";
import { useTheme } from "../../../../contexts/ThemeContext";

interface EmptyStateProps {
  title?: string;
  description?: string;
}

const EmptyState: React.FC<EmptyStateProps> = ({
  title = "No files found",
  description = "Upload files to get started or navigate to a different folder.",
}) => {
  const { theme } = useTheme();
  const isDarkMode = theme === "dark";

  return (
    <div className="flex flex-col items-center justify-center py-12">
      <div
        className={`w-16 h-16 rounded-full flex items-center justify-center mb-4 ${
          isDarkMode ? "bg-rp-surface" : "bg-gray-100"
        }`}
      >
        <FolderOpen
          className={`w-8 h-8 ${isDarkMode ? "text-rp-grey/40" : "text-gray-400"}`}
        />
      </div>
      <h3
        className={`text-lg font-medium mb-1 ${isDarkMode ? "text-rp-grey" : "text-gray-900"}`}
      >
        {title}
      </h3>
      <p
        className={`text-sm text-center max-w-sm ${isDarkMode ? "text-rp-grey/50" : "text-gray-500"}`}
      >
        {description}
      </p>
    </div>
  );
};

export default EmptyState;

